import React, { useEffect } from 'react';
import { Hero } from '../components/sections/Hero';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { WhatYouGet } from '../components/sections/WhatYouGet';
import { HowItWorks } from '../components/sections/HowItWorks';
import { ForWho } from '../components/sections/ForWho';
import { ProofSection } from '../components/sections/ProofSection';
import { FAQSection } from '../components/sections/FAQSection';
import { PriceBlock } from '../components/sections/PriceBlock';
import { Footer } from '../components/Footer';
import { initPixel, trackPageView } from '../utils/pixel';
export function LandingPage() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <main className="w-full" style={{
    backgroundColor: '#FAFAF8'
  }} data-id="element-300">
      <Hero data-id="element-301" />
      <ProblemSection data-id="element-302" />
      <SolutionSection data-id="element-303" />
      <WhatYouGet data-id="element-304" />
      <HowItWorks data-id="element-305" />
      <ForWho data-id="element-306" />
      <ProofSection data-id="element-307" />
      <FAQSection data-id="element-308" />
      <PriceBlock data-id="element-309" />
      <Footer data-id="element-310" />
    </main>;
}